export default {
    subtotal: 'សរុបរង',
    discount: 'បញ្ចុះតម្លៃ',
    tax: 'ពន្ធ',
    vatWithPercent: 'VAT ({percent}%)',
    vatWithoutPercent: 'VAT',
    whtWithPercent: 'WHT ({percent}%)',
    whtWithoutPercent: 'WHT',
    total: 'សរុប',
    year: 'ឆ្នាំ',
    years: 'ឆ្នាំ',
    price: 'តម្លៃ',
    duration: 'រយៈពេល',
    payment_plan: 'កម្រោងទូទាត់',
    loading: 'កំពុងផ្ទុក',
    action: 'សកម្មភាព',
    filter_search: 'តម្រងស្វែងរក',
    search: 'ស្វែងរក',
    from: 'ពី',
    to: 'ទៅ',
    reset: 'កំណត់ឡើងវិញ',
    type: 'ប្រភេទ',
    hello: 'សួស្ដី',
    processing: 'ដំណើរការ',
    choose_file: 'ជ្រើសរើសឯកសារ...',
    drop_file: 'ដាក់ឯកសារទីនេះ...',
    warning: 'ព្រមាន',
    no_more_result: 'គ្មានលទ្ធផលទៀតទេ',
    empty_data: 'គ្មានទិន្នន័យទេ។',
    yes: 'បាទ/ចាស៎',
    no: 'ទេ',
    for: 'សម្រាប់',
    all: 'All',
    browse: 'កម្មវិធីរុករក',
    no_records: 'មិនមានកំណត់ត្រាដែលត្រូវបង្ហាញទេ',
    upgrade_fee: 'ថ្លៃតំឡើង',
    duration_type: {
        MONTH: 'ខែ',
        YEAR: 'ឆ្នាំ',
    },
    duration_short_type: {
        MONTH: 'ខែ',
        YEAR: 'ឆ្នាំ',
    },
    mo: 'ខែ',
    none: 'គ្មាន',
    update_server_name: 'ធ្វើបច្ចុប្បន្នភាព Server name',
    package: 'កញ្ចប់',
    time_extension: 'រយះពេលបន្ត',
    time_extension_hint:
        'បច្ចុប្បន្ន សេវាកម្មរបស់អ្នកនៅសល់តិចជាង 30 ថ្ងៃ សូមជ្រើសរើសរយះពេលបន្តការប្រើប្រាស់យ៉ាងតិច 1 ខែ ដើម្បីធ្វើឱ្យកាន់តែប្រសើរឡើង',
    upgrade_fee_to: 'ថ្លៃដំឡើង (ដល់ថ្ងៃទី {date})',
    extend_fee_to: 'បន្ថែមថ្លៃសេវា (ដល់ {date})',
    extend: 'ពង្រីក',
    current: 'បច្ចុប្បន្ន',
    detail: 'លម្អិត',
    details: 'ព័ត៌មានលម្អិត',
    timezone: 'ម៉ោង តាមតំបន់',
    tos: 'លក្ខខណ្ឌរបស់សេវាកម្ម',
    retry: 'ព្យាយាមម្តងទៀត',
    username: 'ឈ្មោះអ្នកប្រើ',
    on: 'បើក',
    off: 'បិទ',
    note: 'ចំណាំ',
    new: 'New',
    save: 'រក្សាទុក',
    domain: 'ដែន | ដែន',
    of: 'នៃ',
    used: 'បានប្រើ',
    days: 'ថ្ងៃ',
    click_here: 'សូមចុចត្រង់នេះ',
    date: 'កាលបរិច្ឆេទ',
    selected: 'បានជ្រើសរើស',
    select_minute: 'ជ្រើសរើសនាទី',
    select_hour: 'ជ្រើសរើសម៉ោង',
    select_day: 'ជ្រើសរើសថ្ងៃ',
    select_cycle: 'ជ្រើសរើសវដ្ត',
    minute: 'នាទី',
    hour: 'ម៉ោង',
    day: 'ថ្ងៃ',
    monday: 'ថ្ងៃច័ន្ទ',
    tuesday: 'ថ្ងៃអង្គារ',
    wednesday: 'ថ្ងៃពុធ',
    thursday: 'ថ្ងៃព្រហស្បតិ៍',
    friday: 'ថ្ងៃសុក្រ',
    saturday: 'ថ្ងៃសៅរ៍',
    sunday: 'ថ្ងៃអាទិត្យ',
    rename: 'ប្តូរឈ្មោះ',
    hourly: 'រៀងរាល់ម៉ោង',
    daily: 'ប្រចាំថ្ងៃ',
    weekly: 'ប្រចាំសប្តាហ៍',
    monthly: 'ប្រចាំខែ',
    custom: 'រៀបចំ',
    results: 'លទ្ធផល',
    enter_script: 'បញ្ចូលស្គ្រីប',
    copy: 'ចម្លង / ចម្លង',
    confirm: 'បញ្ជាក់',
    unknown: 'មិនស្គាល់',
    region: 'តំបន់',
    month_pluralization: 'ខែ | ខែ',
    description: 'ការបរិយាយ',
    amount: 'ចំនួនទឹកប្រាក់',
    or: 'ឬ',
    company_name: 'ឈ្មោះ​ក្រុម​ហ៊ុន',
    customer: 'អតិថិជន',
    address: 'អាស័យដ្ឋាន',
    description_of_services: 'ការពិពណ៌នាអំពីសេវាកម្ម',
    quantity: 'បរិមាណ',
    unit_price: 'តម្លៃ​ឯកតា',
    mail: 'សំបុត្រ',
    phone_number: 'លេខទូរសព្ទ',
    confirm_status: 'កិច្ចសន្យាត្រូវបានបញ្ជាក់',
    complete: 'រួចរាល់',
    total_invoice: 'វិក្កយបត្រសរុប',
};
